export interface CollectiveAgreementGroup {
	id: string;
	label: string;
}

export interface CollectiveAgreementGroupsResponse {
	collectiveAgreement: string | null;
	groups: CollectiveAgreementGroup[];
}

const getCollectiveAgreementGroups = async (
	token: string,
	companyId: string
): Promise<CollectiveAgreementGroupsResponse> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/companies/${companyId}/collective-agreement-groups`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	// The backend wraps the payload in a { success, data, code } envelope.
	// Reading `.groups` off the envelope yields undefined, so the convenio group
	// selector never populated — a required-but-empty field that silently blocked
	// invites for companies with a collective agreement. Unwrap `data` here.
	const json = await response.json();
	const payload = (json?.data ?? json) as Partial<CollectiveAgreementGroupsResponse>;
	return {
		collectiveAgreement: payload?.collectiveAgreement ?? null,
		groups: payload?.groups ?? []
	};
};

export default getCollectiveAgreementGroups;
